import React from 'react';
import { View, SxProp } from 'dripsy';

import { UniSkeleton } from './UniSkeleton';
import { TextSmall, TextBody } from '../typography/UniTypography';
import { SkeletonView } from './SkeletonView';

export interface UniTextDetails {
  status?: 'default' | 'success' | 'danger';
  subText?: string;
  name: string;
  data: string;
  index?: number;
  loading?: boolean;
  render?: () => React.ReactNode;
}

export interface UniTextDetailsCardProps {
  data: Array<UniTextDetails>;
  sx?: SxProp;
  loading?: boolean;
}

export const UniTextDetailsCard: React.FC<UniTextDetailsCardProps> = (props) => {
  const { data, loading = false, sx } = props;

  return (
    <View sx={{ ...sxStyles.container, ...sx }}>
      {data.map((item, i) => (
        <UniTextDetailsItem {...item} index={i} key={`UniTextDetailsItem-${i}`} loading={loading} />
      ))}
    </View>
  );
};

const UniTextDetailsItem: React.FC<UniTextDetails> = (props) => {
  const { name, data, index, subText, loading = false, status = 'default' } = props;

  return (
    <View sx={{ ...sxStyles.textDetailsItem, mt: index === 0 ? 0 : 12 }}>
      <View sx={{ flex: 1 }}>
        <TextBody secondary>{name}</TextBody>
        {subText && <TextSmall secondary>{subText}</TextSmall>}
      </View>
      <View sx={{ flex: 1, alignItems: 'flex-end' }}>
        {loading && <SkeletonView height={17} width={130} />}
        {!loading && !props.render && (
          <TextBody success={status === 'success'} danger={status === 'danger'}>
            {data}
          </TextBody>
        )}
        {!loading && props.render && props.render()}
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center'
  },
  textDetailsItem: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
};
